<style lang="sass" scoped>
img
  width: 40px
  height: 40px
  border-radius: 20px
.create
  margin-bottom: 20px
  .create-btn
    vertical-align: middle
  .search
    float: right
    .el-input
      width: auto
      margin-right: 10px
.tips
    position: relative
    top: -4px
    left: 3px
    font-size: 12px
.tip-items
  margin-top: 20px
  padding-left: 0
  list-style: none
  li
    line-height: 2
    &:before
      content: ''
      display: inline-block
      width: 16px
      height: 16px
      background: url('../assets/tips.svg') no-repeat
      background-size: 100% 100%
      margin-right: 10px
      vertical-align: middle
      position: relative
      top: -1px
    &.warning
      color: #FF4949
.table-template
  thead
    tr
      th
        &:nth-child(1)
          width: 120px
        &:nth-child(2)
          width: 80px
        &:nth-child(3)
          width: 120px
        &:nth-child(4)
          width: 150px
        &:nth-child(5)
          width: 160px
        &:nth-child(6)
          width: 160px
          padding-left: 4px
  tbody
    tr
      &.no-content a
        color: #50bfff
        &:hover
          color: #20a0ff
      td
        &:nth-child(4)
          &:hover
            .el-tooltip.item
              cursor: pointer
          .el-tooltip.item
            display: inline-block
            max-width: 300px
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            padding-right: 25px
            vertical-align: middle
        &:nth-child(6)
          &:hover
            .el-tooltip.item
              cursor: pointer
          .el-tooltip.item
            display: inline-block
            max-width: 140px
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            vertical-align: middle
        .go-edit
          .edit
            &:before
              background-position: 0 -68em
          &:hover
            color: #2389D0
            .edit
              &:before
                background-position: 0 -70em
        .go-delete
          .delete
            &:before
              background-position: 0 -108em
          &:hover
            color: #C5493C
            .delete
              &:before
                background-position: 0 -110em
.confirm-dialog
  p
    text-align: center
    span
      font-size: 1.25em
      color: #C5493C
</style>
<style lang="sass">
.template-lists
  .el-tabs__item
    width: 50%
    text-align: center
  .el-tabs__nav
    width: 100%
</style>

<template lang="pug">
.wrapper
  headers(:navNum = "navNum", :username = "username")
  .layout-wrapper
    layout
      template(slot="page")
        .create
          router-link.sms-button.create-btn.major(to="/application/create" v-on:click.native="zhuge()") 创建应用
          .search
            el-input.search-item(v-model="params.appName", placeholder="应用名称")
            el-input.search-item(v-model="params.appId", placeholder="app Key")
            el-button.search-button(@click="searchApp()", type="primary") 搜索
        table.table.table-template(v-loading="loading")
          thead
            tr
              th 应用名称
              th 应用图标
              th 应用平台
              th app Key
              th 状态
              th 管理
          tbody
            tr.no-content(v-if="appList && appList.length <= 0")
              td(colspan="7") 暂无应用，立即&nbsp;
                router-link(to="/application/create" v-on:click.native="zhuge()") 创建
            tr(v-if="appList && appList.length > 0", v-for="(item, index) in appList")
              td {{item.appName}}
              td
                img(:src="item.appPicture")
              td {{item.platform === 'i' ? 'IOS' : 'ANDROID'}}
              td {{item.appKey}}
              td
                span.color-green(v-if="item.status === 1") 审核通过
                span.color-yellow(v-else-if="item.status === 2") 审核中
                span.color-red(v-else-if="item.status === 3") 未通过
                span.color-grey(v-else) 删除
              td
                a.go-edit(@click="appInfo(item)", v-if="item.status !== 'success'")
                  span.icon.edit 查看
                a.go-delete(@click="delApplication(item.app_id, index)")
                  span.icon.delete 删除
        el-pagination.pagination(
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="pageTotal")
</template>

<script>
import headers from '../components/headers'
import layout from '../components/layout'
import { mapState } from 'vuex'

export default {
  components: { headers, layout },
  data () {
    return {
      params: {
        from: 0,
        size: 20
      },
      navNum: 3,
      currentPage: 1
    }
  },
  computed: {
    ...mapState({
      appList: state => state.application.appList,
      pageTotal: state => state.application.pageTotal,
      loading: state => state.application.loading,
      username: state => state.dashboard.username
    })
  },
  mounted () {
    this.$store.dispatch('getAppList', this.params)
  },
  methods: {
    zhuge () {
      zhuge.track('一键登录控制台 - 点击创建应用', {
        账号: this.username
      });
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.params.from = (val - 1) * 20
      this.params.size = (val - 1) * 20 + 20
      this.searchApp()
    },
    searchApp () {
      const params = Object.assign({}, this.params)
      if (params.appName !== '' || params.appId !== '') {
        delete params.from
        delete params.size
        this.$store.dispatch('getAppList', params)
      } else this.$store.dispatch('getAppList', this.params)
    },
    appInfo (item) {
      this.$router.push(`/application/info/${item.platform_id}`);
    },
    delApplication (key, index) {
      this.$confirm('此操作将永久删除该应用, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('delApplication', {
          appId: key,
          index: index
        });
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// application.vue?6812f5bd